import React, { useState, useEffect } from "react";
import { UseFormReturnType, useForm } from "@mantine/form";
import { UseMutationResult } from "react-query";
import { Box, Button, Flex, Input, Text, VStack } from "@chakra-ui/react";

interface CustomPricingProps {
  form: UseFormReturnType<any, (values: any) => any>;
  mutation: UseMutationResult<any, any, any, unknown>;
}

type PriceType = {
  [key: string]: string;
};

export const CustomPricing = ({ form, mutation }: CustomPricingProps) => {
  const [prices, setPrices] = useState<PriceType[] | []>([])

  const priceForm = useForm({
    initialValues: {
      key: '',
      value: '',
    },
  });

  useEffect(() => {
    form.setValues({
      ...form.values,
      price: prices
    })
  }, [prices])

  const handleAdd = () => {
    const newPrice = {
      [priceForm.values.key]: priceForm.values.value
    };

    setPrices([...prices, newPrice]);
  };

  return (
    <VStack>
      <Flex w='100%' justifyContent='space-between' gap={5} alignItems='end'>
        <Flex w='100%' gap={2} alignItems='start'>
          <Box w='100%'>
            <Text fontWeight='semibold' color='gray.500' fontSize='sm'>
              Key
            </Text>

            <Box mt='1'>
              <Input
                type="text"
                {...priceForm.getInputProps('key')}
                disabled={mutation.isLoading}
                size='md' mt={1} placeholder="E.g Size 45"
                border={priceForm.errors.key ? '2px' : '1px'}
                borderColor={priceForm.errors.key ? 'red.500' : 'gray.500'} color='gray.500'
                focusBorderColor={priceForm.errors.key ? 'red.500' : 'gray.500'}
                _hover={{ outlineColor: 'transparent' }}
              />
            </Box>
          </Box>

          <Box w='100%'>
            <Text fontWeight='semibold' color='gray.500' fontSize='sm'>
              Value
            </Text>

            <Box mt='1'>
              <Input
                type="number"
                {...priceForm.getInputProps('value')}
                disabled={mutation.isLoading}
                size='md' mt={1} placeholder="E.g: 4000"
                border={priceForm.errors.value ? '2px' : '1px'}
                borderColor={priceForm.errors.value ? 'red.500' : 'gray.500'} color='gray.500'
                focusBorderColor={priceForm.errors.value ? 'red.500' : 'gray.500'}
                _hover={{ outlineColor: 'transparent' }}
              />
            </Box>
          </Box>
        </Flex>

        <Box w='100px'>
          <Button
            onClick={handleAdd}
            isLoading={mutation.isLoading}
            isDisabled={!priceForm.values.key || !priceForm.values.value}
            type='button'
            bg='#37A75B' size="md"
            w='100%' color='white'
            _hover={{ backgroundColor: mutation.isLoading ? '#37A75B' : '#046425' }}
          >
            Add
          </Button>
        </Box>
      </Flex>

      <VStack w='100%' mt={2}>
        {prices.map((price: PriceType, index) => (
          <Box key={index} w='100%'>
            <Text textAlign='left' fontWeight='semibold' color='gray.500'>
              {Object.keys(price)} {Object.values(price)}
            </Text>
          </Box>
        ))}
      </VStack>
    </VStack>
  )
}